import {Typography} from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import {calculateScore, getNumberOfCorrectAnswers, getTotalNumberOfPoints} from './utils';
import React from 'react';
import Icon from '@material-ui/core/Icon';
import {
    Button,
    ButtonGroup,
} from '@material-ui/core';

export default function QuizResultHeader(props){
    const {quizDataDict, userPassed, hideSuccess} = props;
    const TS1 = (props) => (
        <Typography variant="subtitle1" {...props}>
            <Box fontWeight="fontWeightBold">
                {props.children}
            </Box>
        </Typography>);
    const user = quizDataDict.shadowUser;

    const resultText = hideSuccess ? '' :
        userPassed ?
            'Congratulations! You have passed the assessment!' :
            '';
    const resultColor = userPassed ? 'primary' : 'secondary';
    const date = new Date(quizDataDict.createdAt.$date);
    const dateOptions = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };

    return (
        <div>
            {!hideSuccess && <div className="center-all">
                {userPassed && <PassedIcon style={{width: 'auto', height:'auto'}}/>}
                <Typography color={resultColor} variant="h6">{resultText}</Typography>
            </div>}
            {!hideSuccess && <TS1> Your Summary </TS1>}
            <Grid className="center-all" id="quiz-header-summary" container>
                <Grid item xs={3}>
                    <TS1>Name:</TS1>
                </Grid>
                <Grid item xs={3}>
                    {user.userName}
                </Grid>
                <Grid item xs={3}>
                    <TS1>Email:</TS1>
                </Grid>
                <Grid item xs={3}>
                    {user.email}
                </Grid>
                <Grid item xs={3}>
                    <TS1>Score:</TS1>
                </Grid>
                <Grid item xs={3}>
                    {getNumberOfCorrectAnswers(quizDataDict.questions)}/{getTotalNumberOfPoints(quizDataDict.questions)}
                    &nbsp;({calculateScore(quizDataDict)}%)
                </Grid>
                <Grid item xs={3}>
                    <TS1>Passing Grade:</TS1>
                </Grid>
                <Grid item xs={3}>
                    {quizDataDict.options.passFailThreshold}%
                </Grid>
                <Grid item xs={3}>
                    <TS1>Date:</TS1>
                </Grid>
                <Grid item xs={3}>
                    {date.toLocaleString(undefined, dateOptions)}
                </Grid>
                <Grid item xs={3}>
                    <TS1>ID:</TS1>
                </Grid>
                <Grid item xs={3}>
                    {user.platformUserId}
                </Grid>
            </Grid>
        </div>
    );
}

const PassedIcon = (props) => (
    <Icon {...props}>
        <img src="/images/quiz_pass_success.svg" style={{width: 'inherit'}}/>
    </Icon>
);
